import { toReenrolmentMedicalRecords } from './parentHistoryHelpers';

/**
 * What a save of the parent and student information sends.
 *
 * Used both when the parent moves between screens and when they finish, so the two cannot drift
 * apart — a field added to one and forgotten in the other is exactly how answers have gone
 * missing before.
 */
export const buildPersonalandMedPayload = ({
    ParentID,
    SessionID,
    campusSessions = [],
    contact = {},
    recordStatus = {},
    medicalRecords = [],
    familySurname = '',
} = {}) => ({
    u_ParID: ParentID,
    SessionID,
    campusSessions,
    ...contact,
    ...recordStatus,
    StudentMedicalRecords: toReenrolmentMedicalRecords(medicalRecords, familySurname),
});
